import { WritableDraft } from 'immer';

import { FontPack } from '@/types/theme-packs.types';
import { ContentState } from '../types';

const handleFontPackMutations = (updatedFontPack: FontPack, state: WritableDraft<ContentState>) => {
  if (state.fonts?.length) {
    state.fonts = state.fonts.map((pack) => {
      if (pack.font_pack === updatedFontPack.font_pack) {
        return updatedFontPack;
      }
      return pack;
    });
  }
};

export default handleFontPackMutations;
